import { Button } from '@mui/material';
import { faPlay } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

interface BacktestRunPromptProps {
  onRun: () => void;
  isRunning?: boolean;
}

// Holding state shown on the results tabs (Performance / Market Risk / Market
// Data / Transaction Log / Summary) for a backtest that hasn't been run yet —
// the config lives in the Specification tab, so this points the user there and
// offers a Run affordance rather than rendering empty result views.
export const BacktestRunPrompt = ({ onRun, isRunning = false }: BacktestRunPromptProps) => (
  <div className="backtest-run-prompt">
    <h3 className="backtest-run-prompt-title">This backtest hasn&apos;t been run yet</h3>
    <p className="backtest-run-prompt-body">
      Set it up in the Specification tab, then run it to see performance, risk, market data and
      transactions here.
    </p>
    <Button className="backtest-run-prompt-button" onClick={onRun} disabled={isRunning}>
      <FontAwesomeIcon icon={faPlay} />
      <span>{isRunning ? 'Running…' : 'Run backtest'}</span>
    </Button>
  </div>
);
